module.exports = angular.module('cartographer.map.layer', [])

_ = require 'underscore'

module.exports.factory 'crtLayer', $DI (
  crtLog
  crtConfig
  crtPromise
  crtHttp
  crtLocation
  crtDatetime
  crtAttributeLayer
) ->
  # Dictionary of layer plugins, each providing functions like:
  # create a map icon, render a map overlay, etc.
  plugins = {}

  # Register a new plugin
  # string crtFeatureLayer -> void
  registerPlugin = (plugin) ->
    crtLog.debug("Registering layer plugin: #{plugin.id}")
    plugins[plugin.id.toLowerCase()] = plugin
    return

  optFindPlugin = (featureId) ->
    plugins[featureId.toLowerCase()]

  # -> arrayOf(crtFeatureLayer)
  all = ->
    _.values(plugins)

  # string -> crtFeatureLayer
  featureLayer = (featureId) ->
    optFindPlugin(featureId) ? throw new Error("crtLayer.optFindPlugin: no such plugin: #{featureId}")

  # string or(string, null) -> or(crtAttributeLayer, null)
  attributeLayer = (featureId, attrId = null) ->
    feat = featureLayer(featureId)
    if attrId?
      feat.attribute(attrId)
    else if feat.defaultAttribute
      feat.attribute(feat.defaultAttribute)
    else
      null

  # string -> arrayOf(crtFeatureLayer)
  forWorkspace = (workspace) ->
    _.chain(workspace.layers)
     .map(optFindPlugin)
     .filter((plugin) => plugin?)
     .sortBy((plugin) -> plugin.name)
     .value()

  return {
    plugins
    registerPlugin
    optFindPlugin
    all
    featureLayer
    attributeLayer
    forWorkspace
  }
